const mediaItems = [
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Video%20journalism%20news%20reporting%20concept%2C%20abstract%20documentary%20style%20with%20warm%20red%20and%20cream%20tones%2C%20cinematic%20soft%20lighting%2C%20professional%20broadcast%20atmosphere%2C%20clean%20composition&width=800&height=500&seq=media-01&orientation=landscape',
    title: '独家现场：某地大型商场突发安全事件全程直击',
    duration: '15:28',
    views: '52.6万',
    time: '1天前',
    tag: '现场直击',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Interview%20journalism%20documentary%20concept%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20cinematic%20newsroom%20atmosphere%2C%20soft%20dramatic%20lighting%2C%20professional%20video%20production%20style&width=800&height=500&seq=media-02&orientation=landscape',
    title: '深度访谈：知名企业前员工首次公开揭露行业黑幕',
    duration: '22:41',
    views: '38.9万',
    time: '2天前',
    tag: '深度访谈',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Investigative%20documentary%20video%20concept%2C%20warm%20golden%20and%20cream%20tones%2C%20cinematic%20soft%20lighting%2C%20editorial%20news%20style%2C%20professional%20broadcast%20atmosphere%2C%20clean%20minimal%20composition&width=800&height=500&seq=media-03&orientation=landscape',
    title: '暗访调查：记者深入某黑灰产业链全记录',
    duration: '18:56',
    views: '45.3万',
    time: '3天前',
    tag: '暗访调查',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-10 md:mb-14">
          <div>
            <span className="text-xs font-label font-semibold text-primary-500 uppercase tracking-wider">
              视频爆料
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mt-2">
              视频爆料
            </h2>
            <p className="text-foreground-500 text-sm mt-2">
              现场直击视频与深度访谈内容
            </p>
          </div>
          <a
            href="#carousel"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="text-sm text-primary-500 hover:text-primary-600 font-medium mt-4 sm:mt-0 flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看专题报道 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <article
              key={i}
              className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-background-300 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-1 rounded bg-black/60 text-background-50 text-xs font-label">
                  {item.duration}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-2 py-0.5 rounded text-[10px] font-medium bg-primary-100 text-primary-700 mb-3">
                  {item.tag}
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug mb-3 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-4 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                  <span>{item.time}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}